// Module
var code = "<div *ngIf=\"dataUrl\" class=\"calendly-inline-widget\" [attr.data-url]=\"dataUrl\" style=\"min-width:320px;height:700px\"> </div>";
// Exports
module.exports = code;